/** Lightweight public routes, kept separate from the model research narratives. */
export const modelSlugs = ['rank', 'predict', 'plan', 'read', 'test'] as const;
export type ModelSlug = typeof modelSlugs[number];
